module.exports = __webpack_public_path__ + "static/media/document-search.88d4e6b5.svg";